import { baseTheme_default } from './chunk-YD2QUJX6.mjs';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var CodeBlockWrapper = styled(Box)({
  borderRadius: baseTheme_default.spacing(1),
  maxWidth: "100%",
  overflow: "hidden",
  "& pre pre": {
    margin: 0,
    padding: baseTheme_default.spacing(4),
    borderRadius: baseTheme_default.spacing(1),
    overflowX: "auto"
  },
  "& p code": {
    fontFamily: '"SF Mono", Menlo, Monaco, Consolas, monospace',
    fontSize: "0.875rem",
    lineHeight: 1.5,
    backgroundColor: baseTheme_default.palette.primary.main,
    padding: "2px 6px",
    borderRadius: "3px"
  }
});

export { CodeBlockWrapper };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-N3PTFZV7.mjs.map